import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { SsoModalConstant } from '../../../../constants/sso-modal.constant';
import { closeModal } from '../../../../actions/app-modal.action';
import { setSelectedSiNumber, proceedAccToUserPreference } from '../../../../actions/sso-modal.action';
import "./sso-modal.style.css";
import { checkRedirection } from '../../../../actions/dnd-app.action';

class SsoModal extends Component {

    closeModal = () => {
        this.props.closeModal();
        this.props.checkRedirection()
    }

    onAccountSelection = (event) => {
        if (event && event.target && event.target.value) {
            const selectedSiNumber = event.target.value;
            this.props.setSelectedSiNumber(selectedSiNumber);
        }
    }

    onSsoDetailSubmission = () => {
        const { selectedSiNumber, proceedAccToUserPreference } = this.props;
        this.props.closeModal();
        proceedAccToUserPreference(selectedSiNumber);
    }

    render() {
        const { modalTitle, accountList } = this.props;
        return (
            <Fragment>
                <div className="modal-header">
                    <h3 className="margin-top-0 ng-isolate-scope">{modalTitle}</h3>
                    <a className="close" href="javascript:void(0)" onClick={() => this.closeModal()}><i className="icon-outlined-cross"></i></a>
                </div>
                <div className="modal-body">
                    <form name="SsoForm" onSubmit={event => event.preventDefault()} noValidate>
                        <div className="form-group small mb-30">
                            <div class="large form-group horiz-fields mb-40 select-account">
                                <label class="field-title">SELECT NUMBER</label>
                                <select className="account-select" onChange={(event) => this.onAccountSelection(event)}>
                                    {
                                        accountList.map((account, index) => (
                                            //check if sinumber is present
                                            <option key={index} value={account.siNumber}>{account.siNumber}</option>
                                        ))
                                    }
                                </select>
                            </div>
                        </div>
                    </form>
                </div>
                <div className="modal-footer">
                    <div className="action text-right">
                        <button className="btn btn-lg btn-text" onClick={() => this.closeModal()}>{SsoModalConstant.CANCEL}</button>
                        <button type="button" className="btn ng-isolate-scope" onClick={() => this.onSsoDetailSubmission()} autoFocus="">
                            {SsoModalConstant.SUBMIT}
                        </button>
                    </div>
                </div>
            </Fragment>
        );
    }
}

const mapDispatchToProps = dispatch => ({
    closeModal: () => dispatch(closeModal()),
    setSelectedSiNumber: selectedSiNumber => dispatch(setSelectedSiNumber(selectedSiNumber)),
    proceedAccToUserPreference: msisdn => dispatch(proceedAccToUserPreference(msisdn)),
    checkRedirection: () => dispatch(checkRedirection())
})

const mapStateToProps = state => {
    return {
        modalName: state.modalInfo.activeModal.modalName,
        modalTitle: state.modalInfo.activeModal.modalTitle,
        accountList: state.ssoModalInfo.ssoAccountList,
        selectedSiNumber: state.ssoModalInfo.selectedSiNumber
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(SsoModal);